// extracted by mini-css-extract-plugin
module.exports = {"pintxo-pagination-dots":"PaginationDots_pintxo-pagination-dots__e3_LM","pintxo-pagination-dots__container":"PaginationDots_pintxo-pagination-dots__container__lm67Q"};